import React, { useEffect, useState } from 'react'
import axios from 'axios';


import SecurityHeaders from '../../context/SecurityHeaders';
import { Link } from 'react-router-dom';
import SnackbarToast from '../../components/toasts/SnackbarToast';
import DeleteModal from '../../components/modals/DeleteModal';
import { Modal } from 'react-bootstrap';
import EbookItem from './EbookItem';
import AddEbook from './AddEbook';
import { useDispatch } from 'react-redux';
import { useActionsContext } from '../../context/ActionsContext';
import ENDPOINT from '../../context/EndPoint';

const Ebooks = () => {
  const dispatch = useDispatch()
  const [response, setResponse] = useState();
    const { rowsPerPage, setRowsPerPage } = useActionsContext();
  

    const GetBooks = async () => {
      dispatch({ type: 'LOADING' });
      try {
          const data = new FormData();
          // data.append('session', user.SessionId); // Added session for authentication
          data.append('limit', rowsPerPage); // Added limit parameter
  
          const res = await axios.post(ENDPOINT + "get-books.php", data, SecurityHeaders);
          if (res && res.data) {
              if (res.data.status === "success") {
                  dispatch({ type: 'DONE_LOADING' });
                  setResponse(res.data.data || []); // Fallback to empty array if data is null
              } else {
                  dispatch({ type: 'ERROR', payload: res.data.message || 'Failed to fetch books' });
              }
          } else {
              dispatch({ type: 'ERROR', payload: 'No response from server' });
          }
      } catch (err) {
          dispatch({ type: 'ERROR', payload: err.message || 'Error fetching books' });
          console.error('Error fetching books:', err);
      }
  };
  useEffect(() => {
    GetBooks()
  }, [rowsPerPage])


  const [modelShow, setModelShow] = useState(false);

  return (
    <>
      <Modal show={modelShow} onHide={() => setModelShow(false)}>
        <Modal.Body>
          <AddEbook reload={GetBooks} handelClose={() => setModelShow(false)} />
        </Modal.Body>
      </Modal>
      <div className='container' >
        <div className="d-flex justify-content-end">
          <button onClick={() => setModelShow(true)} className='btn btn-primary' >
            Add Book
          </button>
        </div>
        <div className='d-flex flex-wrap col-lg-12  p-2'>

          {
            response ? <>{response.map((item, index) => (


              <EbookItem reload={GetBooks} key={index} item={item} />







            ))}</> : null

          }

        </div>
      </div>
    </>
  )
}

export default Ebooks